
const CommentsIcon = (props: any = {}) => {
    return (
        <svg width="30" height="30" {...props} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="15" cy="15" r="15" fill="#FF947A" />
            <path fillRule="evenodd" clipRule="evenodd" d="M20.3035 20.3024C18.0114 22.5948 14.6173 23.09 11.8398 21.8055C11.4298 21.6404 11.0936 21.507 10.774 21.507C9.88387 21.5123 8.77587 22.3754 8.20002 21.8002C7.62417 21.2243 8.48795 20.1155 8.48795 19.2199C8.48795 18.9003 8.35981 18.5701 8.19474 18.1593C6.90962 15.3822 7.40558 11.987 9.69769 9.6954C12.6237 6.76832 17.3775 6.76832 20.3035 9.69465C23.2348 12.6263 23.2295 17.3761 20.3035 20.3024Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M17.9497 15.3125H17.9565" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14.9497 15.3125H14.9565" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.9419 15.3125H11.9487" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default CommentsIcon